import React, { useContext, useEffect } from "react";
import { FormBuilderContext, ACTIONS } from "../context/context";
import InputSection from "../components/InputSection";
import ColorPickerInput from "../components/ColorPickerInput";
import CustomSelect from "../components/CustomSelect";
import { FormBuilderSwitch } from "../components/Switch";
import FontFamilySelect from "../components/FontFamilySelect";

const PlaceholderGroup = () => {
  const { state, dispatch } = useContext(FormBuilderContext);

  useEffect(() => {
    // Automatically enable placeholders when labels are removed
    if (state.removeFieldLabels && !state.addPlaceholders) {
      dispatch({ type: ACTIONS.TOGGLE_PLACEHOLDERS, payload: true });
    }
  }, [state.removeFieldLabels, state.addPlaceholders, dispatch]);
  


  const handleColorChange = (actionType) => (color) => {
    dispatch({ type: actionType, payload: color });
  };

  const handleFontWeightChange = (event) => {
    dispatch({
      type: ACTIONS.PLACEHOLDER_FONT_WEIGHT_INPUT,
      payload: event.target.value,
    });
  };

  const handleTogglePlaceholders = (event) => {
    dispatch({
      type: ACTIONS.TOGGLE_PLACEHOLDERS,
      payload: event.target.checked,
    });
  };

  const handleFontFamilyChange = (event) => {
    dispatch({
      type: ACTIONS.PLACEHOLDER_FONT_FAMILY_CHANGE,
      payload: event.target.value,
    });
  };

  return (
    <div>
      <div>
        <p>Add placeholder?</p>
        <FormBuilderSwitch
          checked={state.addPlaceholders}
          onChange={handleTogglePlaceholders}
        />
      </div>
      {state.addPlaceholders && (
        <>
          <h2 className="section-subheader">Font styles</h2>
          <div className="input-group-wrapper">
            <div className="form-builder-section-div">
              <p>Font Family</p>
              <FontFamilySelect
                selectedFontFamily={state.placeholderFontFamily}
                onFontFamilyChange={handleFontFamilyChange}
              />
            </div>

            <InputSection
              id="placeholderFontSize"
              title="Font size"
              value={state.placeholderFontSize}
              actionTypeIncrement={ACTIONS.PLACEHOLDER_FONT_SIZE_INCREMENT}
              actionTypeDecrement={ACTIONS.PLACEHOLDER_FONT_SIZE_DECREMENT}
              actionTypeInput={ACTIONS.PLACEHOLDER_FONT_SIZE_INPUT}
              dispatch={dispatch}
            />
            <div>
              <p>Font Weight</p>
              <CustomSelect
                labelId="placeholder-font-weight-select-label"
                id="placeholder-font-weight-select"
                selectValue={state.placeholderFontWeight}
                selectLabel="Select Font Weight"
                selectOnChange={handleFontWeightChange}
                menuItems={[
                  { value: 100, label: "100" },
                  { value: 200, label: "200" },
                  { value: 300, label: "300" },
                  { value: 400, label: "400" },
                  { value: 500, label: "500" },
                  { value: 600, label: "600" },
                  { value: 700, label: "700" },
                  { value: 800, label: "800" },
                  { value: 900, label: "900" },
                ]}
              />
            </div>

            <div>
              <h2 className="section-subheader">Color styles</h2>
              <div className="form-builder-section-div">
                <p>Text Color</p>
                <ColorPickerInput
                  color={state.placeholderColor}
                  onChange={handleColorChange(ACTIONS.PLACEHOLDER_COLOR_INPUT)}
                />
              </div>
            </div>
            <div>
              <h2 className="section-subheader">Hover styles</h2>

              <div className="form-builder-section-div">
                <p>Text Color</p>
                <ColorPickerInput
                  color={state.placeholderHoverColor}
                  onChange={handleColorChange(
                    ACTIONS.PLACEHOLDER_HOVER_COLOR_INPUT
                  )}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PlaceholderGroup;
